import script from "./OrderOversigt.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderOversigt.vue?vue&type=script&setup=true&lang=js"

import "./OrderOversigt.vue?vue&type=style&index=0&id=30f410cf&lang=css"

const __exports__ = script;

export default __exports__